export type LotMessage = {
    editedMessageId: number;
    tlChatId: number;
    tlMessageId: number;
    contactId: number;
    body: string;
    bodyOrigin: string;
    date: Date | string;
    time: string;
    curMien: string;
    type: number; //1 den, 2 di
    tlSenderId?: number; // dùng cho telegram
    htmlError?: string;
    errorText?: string;
    tlChatTitle?: string;
    parserResult?: any | undefined;
    getCompactData: number;
    getRawData: number;
    lockArea: number;
    tlUserId: number;
    loaiBoTinTrung: number;
}
export function LotMessageDefault(): LotMessage {
    const ret: LotMessage = {
        tlChatId: 0,
        tlMessageId: 0,
        contactId: -1,
        body: "",
        bodyOrigin: "",
        date: "",
        time: "",
        curMien: "",
        type: 1, //1 den, 2 di
        tlSenderId: 0, // dùng cho telegram
        htmlError: "",
        errorText: "",
        tlChatTitle: "",
        parserResult: undefined,
        getCompactData: 1,
        getRawData: 0,
        lockArea: 0,
        tlUserId: 0,
        loaiBoTinTrung: 0,
    }
    return ret;
}
export const Dai = {
    DAI_1: 1,
    DAI_2: 2,
    DAI_3: 4,
    DAI_4: 8,
    DAI_HN: 16,
    DAI_5: 32,
    DAI_6: 64,
    DAI_7: 128,
    DAI_8: 256,
}
interface ITeleMessageToSend {
    message: string;
    chatId: string;
}
export class TeleMessageToSend implements ITeleMessageToSend {
    message: string;
    chatId: string;
    constructor() {
        this.message = "";
        this.chatId = ""
    }
}